module.exports = __webpack_public_path__ + "assets/retina_LMidpointDetailed.875cb2d548e8eca3cd64e34d27db9a3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_LMidpointDetailed.png
// module id = 686
// module chunks = 0